import React from 'react'
import QuestionsTemplate from '../../components/templates/question/QuestionsTemplate'

const Questions = () => {
  return (
    <QuestionsTemplate/>
  )
}

export default Questions